import React, { useEffect, useState } from "react"
import { SectionProps } from "../section-loader"
import {
  ContentWrapper,
  SectionWrapper,
  SectionName,
  NewsWrapper,
  NewContent,
  NewLeftBlock,
  NewRightBlock,
  NewAssetWrapper,
  NewAsset,
  NewTitle,
  NewGameName,
  NewGameDate,
  NewDescription,
  NewTitleBlock,
  NewInformationBlock,
  LoadMoreButton
} from "./horizontal-news-elements"
import { Button, Link } from "../../ui"
import { IAllNews, ILink, INews } from "../../../gatsby-graphql"
import SlickSlider from "react-slick"

interface HorizontalNewsProps extends SectionProps {
  data: IAllNews
}

const HorizontalNews = ({ data, locale }: HorizontalNewsProps) => {
  const [loadBundle, setLoadBundle] = useState<INews[]>([])
  const [showLoadMoreButton, setShowLoadMoreButton] = useState(false)
  const showElements = data.maxAmount ? data.maxAmount : 6

  useEffect(() => {
    if (data.itemNews && data.itemNews.length > 0 && !data.isAllNewsDisplayed) {
      setShowLoadMoreButton(true)
      const currentList: INews[] = []
      for (let i = 0; i < showElements; i++) {
        if (data.itemNews[i]) {
          currentList.push(data.itemNews[i] as INews)
        }
      }
      setLoadBundle([...currentList])
    } else if(data.itemNews && data.itemNews.length > 0){
      setLoadBundle([...data.itemNews] as INews[])
    }
  }, [])

  useEffect(() => {
    if (data.itemNews && loadBundle.length >= data.itemNews.length) {
      setShowLoadMoreButton(false)
    }
  }, [loadBundle])

  const loadMore = () => {
    if (data.itemNews && data.itemNews.length > 0) {
      // @ts-ignore
      setLoadBundle([...data.itemNews])
    }
  }

  let setting = {
    infinite: true,
    slidesToShow: Math.min(loadBundle.length, 3),
    arrows: false,
    dots: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          dots: false,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 720,
        settings: {
          dots: true,
          slidesToShow: 1
        }
      }
    ]
  }

  return (
    <SectionWrapper>
      <ContentWrapper>
        <SectionName>{data.title}</SectionName>
        <NewsWrapper>
          {loadBundle.length > 0 ? (
            <SlickSlider
              {...setting}
            >
              {loadBundle.map((newItem: INews, index: number) =>
                <NewContent key={index}>
                  <NewLeftBlock>
                    <NewAssetWrapper>
                      <NewAsset
                        src={newItem.asset?.url ? newItem.asset?.url : ""} alt={"asset"} />
                    </NewAssetWrapper>
                  </NewLeftBlock>
                  <NewRightBlock>
                    <NewTitleBlock>
                      <NewTitle>{newItem?.title}</NewTitle>
                      <NewGameName>{newItem?.gameName}</NewGameName>
                    </NewTitleBlock>
                    <NewInformationBlock>
                      <NewDescription>{newItem?.description}</NewDescription>
                      {newItem.readMore?.link && <Button type={"transparencyLink"}
                              link={newItem.readMore?.link}
                              locale={locale}
                      >{newItem.readMore?.text}</Button>}
                    </NewInformationBlock>
                  </NewRightBlock>
                </NewContent>
              )}
            </SlickSlider>
          ) : <></>}
        </NewsWrapper>
        {showLoadMoreButton ? (<LoadMoreButton>
          <Button type={"transparency"}
                  link={data?.loadMore?.link as ILink}
                  locale={locale}
          >{data?.loadMore?.text}</Button>
        </LoadMoreButton>) : (<></>)}
      </ContentWrapper>
    </SectionWrapper>
  )
}

export default HorizontalNews
